module.exports = __webpack_public_path__ + "images/upgrade-success-soccer.c876fc3e091b8e060693029c89766b8b.jpg";